import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

type IAchievementsSlice = {recommendation?:string}

export const AchievementsSlice = createSlice({
  name: "AchievementsSlice",
  initialState: {} as IReduxState<IAchievementsSlice>,
  reducers: {
    ListAchievements: (state) => {
      state.isLoading = true;
    },
    successAchievements: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureAchievements: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAchievements: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureAchievements,
  successAchievements,
  clearAchievements,
  ListAchievements,
} = AchievementsSlice.actions;

export default AchievementsSlice.reducer;
